// use-fetch-data.js
import { useEffect, useState } from "react";
import { GET_WORKACTIVITY_TECHINICALDEPUTY } from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";

export interface ReqWork {
  id: number;
  name: string;
}
const api = new APIClient();

interface ReqWorksList {
  workActivities: ReqWork[];
}

let val: ReqWorksList;

const useFetchDataWorkList = () => {
  const [allWorks, setData] = useState(val);
  const [loadingAllworks, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        await api
          .get(GET_WORKACTIVITY_TECHINICALDEPUTY, null)
          .then((response) => {
            setData(JSON.parse(JSON.stringify(response)));
            setLoading(false);
          });
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  return {
    allWorks,
    loadingAllworks,
  };
};

export default useFetchDataWorkList;
